import { UIElement } from '../ui-element';
import styles from './ui-journey.css';
import './ui-journey-item';
import { Component } from '../../decorators/component.decorator';
import { Children } from '../../decorators/child.decorator';
import { UIJourneyItem } from './ui-journey-item';
import { Mapped } from '../../global/constants';

/**
 * Description:
 * `ui-journey` acts as a container for multiple `ui-journey-item` elements.
 * It checks whether every child item provides a non-empty `img` attribute and sets `show-images`
 * accordingly (`"true"` only if all have images). Child nodes are re-attached via `updateElement`.
 */

@Component(
    {
        tag: 'ui-journey',
        styles,
    },
    Mapped.True
)
export class UIJourney extends UIElement {
    @Children('ui-journey-item', Mapped.True) items?: UIJourneyItem;

    /**
     * Checks if every provided `ui-journey-item` element has a non-empty `img` attribute.
     * @param items - Array of `Element` objects representing journey items.
     * @returns `true` if all items have a non-empty `img` attribute, otherwise `false`.
     * @private
     */
    private allItemsHaveImages(items: Array<Element>): boolean {
        return items.every(
            (item) =>
                item.hasAttribute('img') && item.getAttribute('img')?.trim()
        );
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.setAttribute('role', 'list');
        const items = Array.from(this.querySelectorAll('ui-journey-item'));
        const hasAllImages = this.allItemsHaveImages(items);

        this.setAttribute('show-images', hasAllImages.toString());
        this.updateElement({
            classList: { 'ui-journey': true },
            children: this.detachChildNodes(),
        });
    }
}
